import UserLabel from "./UserLabel";
export default UserLabel;
